import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EfSpec from '@elem/ui/ef-spec';

let titleSceneC: any = null;
export default function OEu() {
    const { useLang, useRouter, useEffect, useState, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta_pro_ultra.launch.detail.OEu');
    const [textEnter, setTextEnter] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (titleSceneC) {
                    AniContainer.removeScene(titleSceneC);
                    titleSceneC = null;
                }

                const clientH = (window.innerHeight || 0) * 0.2;
                const startH = Math.min(clientH, 150);
                titleSceneC = AniContainer.create({
                    triggerElement: '.OEu-detail .sticky-box',
                    triggerHook: 1,
                    offset: '50%',
                    duration: 200,
                    onEnter: () => {
                        setTextEnter(true);
                    },
                });
            };
            resizeAni();
            return () => {
                if (titleSceneC) {
                    AniContainer.removeScene(titleSceneC);
                    titleSceneC = null;
                }
            };
        }
    }, []);

    return (
        <>
            <section className={`OEu-detail shp2-detail-C OEu-detail-section ${css['OEu-detail']}`} id="OEu-detail">
                <div className={`sticky-box ${textEnter ? 'enter' : ''}`}>
                    <div className="img-box">
                        <EFPicture
                            src={'https://websiteoss.ecoflow.com/upload/image/1748247685854/DPU%2BSHP2_Nightfall%20House%202.jpg'}
                            srcPad="https://websiteoss.ecoflow.com/upload/image/1748247791948/Frame%201612707575.jpg"
                            alt={t('secOEu_title')}
                        />
                        <div className="mask"></div>
                        <div className="title-box">
                            <h2 className="title">{t('secOEu_title')}</h2>
                            <h2 className="desc">{t('secOEu_desc')}</h2>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
